

import React from "react";
import Typography from '@mui/material/Typography';

const getSelectOptions = (selection,row) => (
    selection.map(optionItem => {
        return (optionItem === row.value) ?
            <option value={optionItem} selected >
                {optionItem}
            </option>
            :
            <option value={optionItem}>
                {optionItem}
            </option>
    })
);

const FilterSelector = (props) => {
    return (
        <React.Fragment>
            <Typography variant={"h6"}> {props.title} </Typography>
            <select 
                name={props.name}
                value={props.value} 
                onChange={props.changeSelection} 
                style={{width: "160px"}}>
                    { getSelectOptions(props.selection, props.value)}
            </select>
        </React.Fragment>  
    );
}

export default FilterSelector;

                    